<div class="modal-overlay">
  <div class="modal-content">
    @if (isLoading) {
      <div class="spinner-container">
        <div class="spinner">
          <app-nada-spinner [message]="progressMessage"></app-nada-spinner>
        </div>
      </div>
    }
    <div class="header">
      <span class="title">{{ title }}</span>
      <span class="icon" (click)="onCloseClicked($event)">✖</span>
    </div>
    <div class="content">
      <h6 class="title-options">
        {{ mode === "pdf" ? "Print Options" : "Data Options" }}:
      </h6>
      <div class="divider"></div>
      @for (option of options; track option.label) {
        <div class="option-row">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="option.checked" />
            <span>{{ option.label }}</span>
          </label>
        </div>
      }
      @if (mode === "pdf") {
        <div class="option-row">
          <app-custom-switch
            [(checked)]="isPageLayoutEnabled"
            (checkedChange)="togglePageLayout()"
            label="Page Layout"
          >
          </app-custom-switch>
        </div>
      }
      @if (isPageLayoutEnabled) {
        <div class="page-layout-options">
          <div class="option-row horizantal-line">
            <div class="form-field">
              <label for="reportTitle">Report Title</label>
              <input
                type="text"
                id="reportTitle"
                name="reportTitle"
                [(ngModel)]="reportTitle"
                placeholder="Enter new group name"
                (keypress)="restrictSpecialChars($event)"
                maxlength="100"
              />
            </div>
          </div>
          <div class="option-dropdowns">
            <div class="dropdown">
              <app-custom-dropdown
                [(ngModel)]="pageSize"
                label="Page Size"
                [options]="pageSizeOptions"
              />
            </div>
            <div class="dropdown">
              <app-custom-dropdown
                [(ngModel)]="orientation"
                label="Page Size"
                [options]="orientationOptions"
              />
            </div>
          </div>
        </div>
      }
    </div>
    <div class="button-row">
      <button
        class="primary-button"
        (click)="onPrimaryButtonClicked($event)"
        [disabled]="isLoading"
      >
        {{ mode === "excel" ? "EXPORT TO EXCEL" : "View and Print" }}
      </button>
    </div>
  </div>
</div>
